import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import store from './store/index'
import mainInit from './lib/init'

import DatetimePicker from 'vuetify-datetime-picker'
import VueMask from 'v-mask'

Vue.use(DatetimePicker)
Vue.use(VueMask)
Vue.use(require('vue-moment'));

Vue.config.productionTip = false
// load session to store if available
mainInit()

export const evBus = new Vue()

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
